import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

class CouponIcon extends React.PureComponent {
  render() {
    return (
      <SvgIcon {...this.props}>
      <path
        d="M 0,0 H 24 V 24 H 0 Z"
        id="path2"
        style={{fill:'none', strokeWidth: 0.33333334}} />
      <path
        d="M 21.41,11.58 12.415,2.585 C 12.05,2.225 11.55,2 11,2 H 4 C 2.895,2 2,2.895 2,4 v 7 c 0,0.555 0.225,1.055 0.59,1.415 l 9,9 C 11.95,21.775 12.45,22 13,22 c 0.55,0 1.055,-0.225 1.415,-0.585 l 7,-7 C 21.775,14.05 22,13.55 22,13 22,12.445 21.775,11.945 21.41,11.58 Z M 5.5,7 C 4.67,7 4,6.33 4,5.5 4,4.67 4.67,4 5.5,4 6.33,4 7,4.67 7,5.5 7,6.33 6.33,7 5.5,7 Z"
        id="path4"
        style={{strokeWidth: 0.33333334}} />
      </SvgIcon>
    )
  }
}

export default CouponIcon



// WEBPACK FOOTER //
// ./src/js/components/Mui/CouponIcon.js